<template>
  <b-container fluid class="d-flex justify-content-center bg-light py-5">
   <b-card
      class="custom-card p-1 d-flex align-items-center"
      style="max-width: 720px;"
    >
      <b-row class="align-items-center w-100 no-gutters">
        <b-col cols="12" md="6" class="text-center mb-3 mb-md-0">
          <b-img
            src="@/assets/images/silvia/silvia.png"
            alt="Imagem ilustrativa"
            fluid
            rounded="lg"
            class="img-quality"
          />
        </b-col>

        <b-col cols="12" md="6" class="text-center px-md-4">
          <div class="icon-circle mx-auto mb-2 ">
            <i class="fas fa-info-circle"></i>
          </div>

          <p class="text-dark mb-2 ml-3 text-justify-center">
            <strong>
              Você não tem permissão para acessar este recurso.
            </strong>
          </p>

          <b-link :to="homeRoute" class="link">Clique aqui para voltar para a tela inicial</b-link>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { BCard, BImg, BContainer, BRow, BCol, BLink } from 'bootstrap-vue'
import { getHomeRoute } from '@/utils/home-route'

export default {
  components: { BContainer, BCard, BImg, BRow, BCol, BLink },
  computed: {
    homeRoute() {
      return getHomeRoute()
    },
  },
}
</script>

<style scoped lang="scss">
.img-quality {
  max-width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
  border-radius: 12px;
}

.text-justify-center {
  text-align: center;
  line-height: 1.5;
}

.icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #2E2C6C1a; 
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  transform: translateX(10px); 

  i {
    font-size: 28px;
    color: #2E2C6C;
  }
}

.text-justify-center {
  text-align: center;
  line-height: 1.5;
  margin-left: 10px; 
}

.link {
  display: inline-block;
  margin-left: 45px; 
  color: #6e6b7b;
  text-decoration: none;
  position: relative;
  font-weight: 500;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 2px;
    background: #2E2C6C;
    transition: width 0.4s;
  }

  &:hover {
    color: #2E2C6C !important;
    &:after {
      width: 100%;
    }
  }
}

.custom-card {
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15); 
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2); 
  }
}

</style>
